import { useEffect, useState } from "react";

type Validation = (value: any) => boolean;
const useStateHandler = <T>(validation: Validation, baseValue: T) => {
  const [value, setValue] = useState<T>(baseValue);
  const [isValid, setValidValue] = useState<boolean>(validation(value));

  useEffect(() => {
    setValidValue(validation(value));
  }, [value]);

  const handler = (event: { target: { value: T } }) => {
    setValue(event.target.value);
  };

  return { value, isValid, setValue, handler };
};

export default useStateHandler;
